import clsx from 'clsx';

import { ProductCardPlaceholder } from '~/features/products/components/ProductCard/ProductCardPlaceholder';

import styles from './M30ProductCarousel.module.css';

const placeholderItemArray = new Array(6).fill(0);

export const M30CarouselPlaceholder = () => (
	<div className={styles.placeholderCarouselWrapper}>
		<div className={styles.placeholderCarousel}>
			{placeholderItemArray.map((_, i) => (
				<div
					className={clsx(styles.carouselItem, styles.placeholderItem)}
					key={i}
				>
					<ProductCardPlaceholder />
				</div>
			))}
		</div>
	</div>
);
